import React, { useState } from 'react'

import { useTranslation } from 'react-i18next'
import { connect, DataItem } from 'scrivito'

import { Card } from '@/Atomic/Atoms/Card'
import { InlineCustomField } from '@/Atomic/Organisms/CustomField/InlineCustomField'
import { getDataItemFormMap } from '@/utils/CRUD/read/dataItem/getDataItemMap'

import './style.scss'

interface DataItemDetailsProps {
  dataItem: DataItem
}

export const DataItemDetails: React.FC<DataItemDetailsProps> = connect(
  ({ dataItem }) => {
    const { t } = useTranslation()
    const [editingField, setEditingField] = useState('')

    const dataItemGroups = getDataItemFormMap(dataItem)

    return (
      <>
        <div className="group-header">{t('common.details', 'Details')}</div>
        {dataItemGroups.map((group, idx) => (
          <div key={group.name} className="pb-24">
            {idx !== 0 && <div className="group-header">{group.title}</div>}
            <Card>
              <div className="grid-container">
                {group.fields.map((field) => (
                  <React.Fragment key={field.name}>
                    <span className="grid-item key">{field.title}</span>
                    <InlineCustomField
                      dataItem={dataItem}
                      fieldMap={field}
                      editingField={editingField}
                      setEditingField={setEditingField}
                    />
                  </React.Fragment>
                ))}
              </div>
            </Card>
          </div>
        ))}
      </>
    )
  },
)
